
























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { CruiseTeamData, emptyCruiseTeam, removeData, getList, getMembers, postMembers, deleteMember } from '@/api/cruiseTeam/index'
import { paramToUrl, toDefaultStr, toDefaultInt, tryToStr, tryToInt } from '@/configs/functions'
import { PermissionData, PagePermissionState, FailedPermission } from '@/store/modules/pagePermission'
import { namespace } from 'vuex-class'
import CruiseTeamSearchMembers from '@/components/cruiseTeam/searchMembers.vue'
import CruiseTeamModify from '@/components/cruiseTeam/modify.vue'
import PageList from '@/components/pageLayout/list.vue'

const PagePermissionModule = namespace('pagePermission')

@Component({
  components: { PageList, CruiseTeamModify, CruiseTeamSearchMembers }
})
export default class CruiseTeamList extends Vue {
  @PagePermissionModule.Getter('pagePermission')
  public pagePermission!: PagePermissionState

  public get btnCtrl(): PermissionData {
    const s = this.pagePermission
    if (this.$route.path === s.pagePath) {
      return s.permission
    }
    return FailedPermission
  }

  // dynamic component
  public $refs!: {
    modifyCtrl: CruiseTeamModify
    searchMembersCtrl: CruiseTeamSearchMembers
  }
  public list: any = []
  public listLoading: boolean = true
  public childLoading = true
  public totalItems: number = 0
  public totalPages: number = 0
  public pageSize: number = window.baseConfig.PageSize
  public queryTerm = {
    Page: 1,
    PageSize: this.pageSize,
    SortBy: 'SubSequence',
    IsAsc: true,

    MemberId: 0,
    Keyword: ''
  }
  get startIndex() {
    return this.queryTerm.PageSize * (this.queryTerm.Page - 1) + 1
  }
  public expandKeys: number[] = []
  public expandClass(id: number): string {
    if (this.expandKeys.findIndex(v => v == id) > -1) {
      return 'el-icon-arrow-down'
    }
    else {
      return 'el-icon-arrow-right'
    }
  }
  public rowExpand(index: number, event: any, column: any) {
    this.parentIndex = index
    var row = this.list[index]
    var index = this.expandKeys.findIndex(v => v == row.Id)
    if (index < 0) {
      if (!row.childs || row.childs.length == 0) {
        this.fetchChilds()
      }
      //展开，查询子级
      this.expandKeys.push(row.Id)
    } else {
      // 移除展开项      
      this.expandKeys.splice(index, 1)
    }
  }
  public fetchChilds() {
    if (this.parentIndex > -1) {
      var row = this.list[this.parentIndex]
      row.childs = []
      this.childLoading = true
      getMembers(row.Id).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          row.childs = data
          this.$set(this.list, this.parentIndex, row)
          this.childLoading = false
        }
      })
    }
  }
  public openCruiseTeamDialog(id: number) {
    window.eventBus.$emit('openCruiseTeamModify', id)
  }
  public doAdd() {
    this.parentIndex = -1
    this.openCruiseTeamDialog(0)
  }
  public parentIndex: number = -1
  public doAddMember(index: number) {
    this.parentIndex = index
    var teamId = this.list[index].Id
    window.eventBus.$emit('openCruiseTeamSearchMembers', teamId)
  }
  public doEdit(index: number) {
    this.parentIndex = index
    var row = this.list[index]
    this.openCruiseTeamDialog(row.Id)
  }
  public doDel(id: number) {
    this.$confirm('确定要删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      removeData(id).then((response: { data: any }) => {
        const data = response.data
        if (data && !data.IsError) {
          this.$message({ type: 'success', message: '删除成功' })
          this.fetchData()
        }
        else {
          this.$message({ type: 'warning', message: data.Message })
        }
      })
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消操作'
      })
    })
  }
  public doDelMember(index: number, childIndex: number) {
    var e = this.list[index].childs[childIndex]
    this.$confirm('确定要删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deleteMember(e.UserTeamId).then((response: { data: any }) => {
        const data = response.data
        if (data && !data.IsError) {
          this.$message({ type: 'success', message: '删除成功' })
          // this.refreshData()
          this.list[index].childs.splice(childIndex, 1)
        }
        else {
          this.$message({ type: 'warning', message: data.Message })
        }
      })
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消操作'
      })
    })
  }
  public bindEventBus() {
    window.eventBus.$on('submitCruiseTeamModify', (data: CruiseTeamData) => {
      if (this.parentIndex > -1 && this.expandKeys.findIndex(v => v == data.Id) > -1) {
        data.childs = this.list[this.parentIndex].childs
        this.$set(this.list, this.parentIndex, data)
      }
      else {
        this.refreshData()
      }
    })
    window.eventBus.$on('submitCruiseTeamSearchMembers', (data: any) => {
      var userIds = data.map((v: any) => { return v.Id })
      var row = this.list[this.parentIndex]
      var teamId = row.Id
      postMembers(teamId, userIds).then((response: { data: any }) => {
        const data = response.data
        if (data && !data.IsError) {
          this.$message({ type: 'success', message: '巡查人员添加成功' })
          this.fetchChilds()
          /*
          this.childLoading = true
          getMembers(teamId).then((response: { data: any }) => {
            const data = response.data
            if (data) {
              row.childs = data
              this.$set(this.list, this.parentIndex, row)
              this.childLoading = false
            }
          })
          */
        }
        else {
          this.$message({ type: 'warning', message: data.Message })
        }
      })
    })
  }
  public destroyEventBus() {
    window.eventBus.$off('submitCruiseTeamModify')
    window.eventBus.$off('submitCruiseTeamSearchMembers')
  }
  public getQueryTerm() {
    const query = this.$route.query
    // 从页面Url中获取参数
    this.queryTerm = {
      PageSize: toDefaultInt(query['PageSize'], this.pageSize),
      Page: toDefaultInt(query['Page'], 1),
      SortBy: toDefaultStr(query['SortBy'], 'SubSequence'),
      IsAsc: toDefaultStr(query['IsAsc'], 'true') == 'true',
      MemberId: tryToInt(query['MemberId']),
      Keyword: tryToStr(query['Keyword'])
    }
  }
  public created() {
    this.getQueryTerm()
    this.fetchSource()
  }
  public mounted() {
    this.bindEventBus()
    this.fetchData()
  }
  // 点击查询按钮时，页码需要重置为1
  public doSearch() {
    this.queryTerm.Page = 1
    this.fetchData()
  }
  public beforeDestroy() {
    //销毁事件，避免重复注册
    this.destroyEventBus()
  }
  // 数据项加载
  public fetchSource() {
  }
  public fetchData() {
    this.listLoading = true
    getList(this.queryTerm).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        this.list = data.Results
        this.totalPages = data.TotalPages
        this.totalItems = data.TotalCount
        this.listLoading = false
      }
    })
  }
  public refreshData() {
    this.queryTerm.SortBy = 'UpdateDate'
    this.queryTerm.IsAsc = false
    this.queryTerm.Page = 1
    this.expandKeys = []
    this.fetchData()
  }
  // 在当前路由改变，但是该组件被复用时调用
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
  // 分页按钮点击的时候，按新分页查询数据
  public pageEvent() {
    this.fetchData()
  }
}
